import React from "react";
import { Currency } from "../../common";
import { renderNumber } from "@share/utils";

interface StatCardProps {
  iconClass: string;
  isMoney: boolean;
  value: string;
  label: string;
  style?: string
}

const StatCard: React.FC<StatCardProps> = (props) => {
  const { iconClass, isMoney, value, label , style } = props;
  return (
    <div className="col-sm-6 col-xl-3">
      <div className="d-flex align-items-center">
        <span className="display-6 text-primary">
          <i className={iconClass}></i>
        </span>
        <div className="ms-3">
          <h4 className={`mb-0 ${style && style}`}>{isMoney ? <Currency currency="USD" /> : null}{renderNumber(Number(value), isMoney ? 2 : 0)}</h4>
          <span>{label}</span>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
